<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="1">
            <div class="row p-3">
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                <label>{{ $t('common_words.farm') }} *</label>
                <br />
                <el-select
                  id="cut_summary_farm"
                  clearable
                  @change="showCalendar()"
                  v-bind:collapse-tags="true"
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="cutSummaryCatchingForm.farm_id"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in farms"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
                v-if="isShowCalendar"
              >
                <label>{{ $t('common_words.production_calendar') }}</label>
                <br />
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-calendar shadow-sm"
                  size="large"
                  v-model="cutSummaryCatchingForm.calendar_sel"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in calendars"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-8 col-md-4 col-lg-4 col-xl-3">
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-date-picker
                  v-if="renderComponent"
                  id="cut_summary_date_picker"
                  v-model="cutSummaryCatchingForm.date"
                  class="shadow-sm required-year"
                  v-bind:type="typedatepicket"
                  :picker-options="pickerOptions"
                  :placeholder="`${$t('common_words.select2')}...`"
                >
                </el-date-picker>
              </div>
              <div class="col-12 col-md-4 col-xl-2">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <l-button wide type="info" class="btn-filter" @click="validate">
                  {{ $t('common_words.filter') }}
                </l-button>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </card>
      <br />
      <div v-if="messageAlert" class="alert alert-warning" role="alert">
        {{ messageAlert }}
      </div>
      <card
        class="custom-shadow-card-header custom-table-responsive"
        :title="$t('common_words.generals')"
        v-if="summaryCatching"
      >
        <div class="col-sm-12">
          <table class="table table-striped table-bordered">
            <thead>
              <tr class="cusmtom-thead-color">
                <th class="text-center p-3 custom-header-label">
                  {{ $t('common_words.general_mayus') }}
                </th>
                <th class="text-center p-3 custom-header-label">
                  {{ $t('common_words.value_mayus') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in generalData">
                <td>{{ data.data_name }}</td>
                <td>
                  <el-input
                    min="0"
                    type="number"
                    v-validate="'decimal'"
                    class="text-center"
                    @change="validateNegative(index, 'general')"
                    v-model="generalData[index].value"
                  >
                    {{ data.value }}
                  </el-input>
                </td>
              </tr>
              <tr v-for="(data, index) in totalDataGeneral">
                <td>
                  <strong>{{ data.data_name }}</strong>
                </td>
                <td>{{ data.value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </card>
      <br />
      <card
        class="custom-shadow-card-header custom-table-responsive"
        :title="$t('production.cluster_fruit_cutted')"
        v-if="summaryCatching"
      >
        <div class="col-sm-12">
          <table class="table table-striped table-bordered">
            <thead>
              <tr class="cusmtom-thead-color">
                <th class="text-center p-3 custom-header-label">
                  {{ $t('production.motive') }}
                </th>
                <th
                  class="text-center p-3 custom-header-label"
                  v-bind:style="{ minWidth: '100px' }"
                >
                  {{ $t('production.ribbon_mayus') }}
                </th>
                <th class="text-center p-3 custom-header-label">
                  {{ $t('common_words.quantity_mayus') }}
                </th>
                <th class="text-center p-3 custom-header-label">
                  {{ $t('production.calibration_mayus') }}
                </th>
                <th
                  v-if="!messageAlert"
                  class="text-center p-3 custom-header-label"
                ></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in cutData">
                <td>
                  <el-select
                    clearable
                    filterable
                    class="select-primary custom-width-select required-calendar shadow-sm"
                    size="large"
                    v-model="data.week"
                    :disabled="data.week ? true : false"
                    @change="changeWeek"
                  >
                    <el-option
                      class="select-primary"
                      v-for="ribbon of avaliableWeeks"
                      :value="ribbon.week"
                      :label="ribbon.week"
                      :key="`week-${ribbon.week}`"
                    ></el-option>
                  </el-select>
                </td>
                <td :style="{ backgroundColor: data.color_code }"></td>
                <td>
                  <el-input
                    type="number"
                    class="text-center"
                    min="0"
                    @change="validateNegative(index, 'cutNumber')"
                    v-model="cutData[index].number_clusters"
                  >
                  </el-input>
                </td>
                <td>
                  <el-input
                    type="number"
                    v-validate="'decimal'"
                    class="text-center"
                    min="0"
                    v-model="cutData[index].calibration"
                    @change="validateNegative(index, 'cutCalibration')"
                  ></el-input>
                </td>
                <td v-if="!messageAlert">
                  <div class="text-center">
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.add')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="addWeek"
                    >
                      <em class="fa fa-plus custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete() && cutData.length > 1"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="deleteWeek(index)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="text-center">
                  <strong>{{ $t('common_words.total') }}</strong>
                </td>
                <td class="text-center"></td>
                <td class="text-center">
                  <strong>{{ totalCluster }}</strong>
                </td>
                <td class="text-center">
                  <strong>{{ totalCalibration }}</strong>
                </td>
                <td v-if="!messageAlert" class="text-center">
                  <strong></strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
      </card>
      <br />
      <card
        class="custom-shadow-card-header custom-table-responsive"
        :title="$t('production.cluster_fruit_rejected')"
        v-if="summaryCatching"
      >
        <div class="col-sm-12">
          <table class="table table-striped table-bordered">
            <thead>
              <tr class="cusmtom-thead-color">
                <th class="text-center p-3 custom-header-label">
                  {{ $t('production.motive_mayus') }}
                </th>
                <th class="text-center p-3 custom-header-label">
                  {{ $t('common_words.quantity_mayus') }}
                </th>
                <th
                  v-if="!messageAlert"
                  class="text-center p-3 custom-header-label"
                ></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in recusados">
                <td>
                  <el-select
                    clearable
                    filterable
                    class="select-primary custom-width-select required-calendar shadow-sm"
                    size="large"
                    v-model="recusados[index].cause_id"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      v-for="(option, index) in causes"
                      class="select-primary"
                      :value="option.id"
                      :label="option.name"
                      :key="index + option.id"
                    ></el-option>
                  </el-select>
                </td>
                <td>
                  <el-input
                    class="text-center"
                    type="number"
                    min="0"
                    @change="validateNegative(index, 'rejected')"
                    v-model="recusados[index].amount"
                  >
                  </el-input>
                </td>
                <td v-if="!messageAlert">
                  <div class="text-center">
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.add')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="addRecusado"
                    >
                      <em class="fa fa-plus custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete() && recusados.length > 1"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="deleteRecusado(index)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="text-center">
                  <strong>{{ $t('common_words.total') }}</strong>
                </td>
                <td class="text-center">
                  <strong>{{ totalRecusados }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
      </card>
      <br />
      <card v-if="summaryCatching" title="Cajas">
        <div class="col-sm-12">
          <table class="table table-striped table-bordered">
            <thead>
              <tr class="cusmtom-thead-color">
                <th class="text-center p-3 custom-header-label">
                  {{ $t('production.box_mayus') }}
                </th>
                <th class="text-center p-3 custom-header-label">
                  {{ $t('production.crafted_mayus') }}
                </th>
                <th class="text-center p-3 custom-header-label">
                  {{ $t('production.rejected_mayus_2') }}
                </th>
                <th class="text-center p-3 custom-header-label">
                  {{ $t('common_words.exported_mayus') }}
                </th>
                <th
                  v-if="!messageAlert"
                  class="text-center p-3 custom-header-label"
                ></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in boxesData">
                <td>
                  <el-select
                    clearable
                    filterable
                    class="select-primary custom-width-select required-calendar shadow-sm"
                    size="large"
                    v-model="data.box_id"
                  >
                    <el-option
                      v-for="box in boxes"
                      class="select-primary"
                      :value="box.id"
                      :label="box.name"
                      :key="`box-${box.id}`"
                    ></el-option>
                  </el-select>
                </td>
                <td>
                  <el-input
                    type="number"
                    class="text-center"
                    @change="calcExported(index)"
                    clearable
                    min="0"
                    v-model="boxesData[index].number_boxes"
                  >
                  </el-input>
                </td>
                <td>
                  <el-input
                    type="number"
                    class="text-center"
                    @change="calcExported(index)"
                    clearable
                    min="0"
                    v-model="boxesData[index].number_rejected"
                  >
                  </el-input>
                </td>
                <td>
                  <el-input
                    type="number"
                    class="text-center"
                    clearable
                    disabled
                    min="0"
                    v-model="boxesData[index].number_exported"
                  >
                  </el-input>
                </td>
                <td v-if="!messageAlert">
                  <div class="text-center">
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.add')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="addBox"
                    >
                      <em class="fa fa-plus custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete() && boxesData.length > 1"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="deleteBox(index)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="text-center">
                  <strong>{{ $t('common_words.total') }}</strong>
                </td>
                <td class="text-center">
                  <strong>{{ totalBoxes }}</strong>
                </td>
                <td class="text-center">
                  <strong>{{ totalRejectedBoxes }}</strong>
                </td>
                <td class="text-center">
                  <strong>{{ totalExportedBoxed }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
      </card>
      <br />
      <card v-if="summaryCatching && !messageAlert">
        <div class="row">
          <div class="col-6 text-right" v-if="isCreate() || isUpdate()">
            <l-button
              wide
              type="info"
              class="btn-filter m-4"
              @click="saveSummary"
            >
              {{ $t('common_words.save') }}
            </l-button>
          </div>
          <div class="col-6 text-left" v-if="isDelete()">
            <l-button
              wide
              type="danger"
              class="btn-filter m-4"
              @click="deleteSummary"
            >
              {{ $t('common_words.delete') }}
            </l-button>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import store from '@/store';
import { mapActions } from 'vuex';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import i18n from 'src/i18n';

export default {
  data() {
    return {
      cutSummaryCatchingForm: {
        date: null,
        farm_id: null,
        calendar_sel: null,
        cut_summary_id: null,
      },
      typedatepicket: 'date',
      activeName: '1',
      valueCollapse: null,
      farms: [],
      years: [],
      boxes: [],
      ribbonsWeeks: [],
      isShowCalendar: false,
      summaryCatching: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      generalData: [],
      cutData: [],
      totalDataCut: [],
      totalDataGeneral: [],
      recusados: [],
      // totalRecusados:[],
      boxesData: [],
      // totalBoxes:[],
      causes: [],
      messageAlert: null,
    };
  },

  mixins: [MixinPermissions, mixinMasters],

  computed: {
    totalCluster() {
      let result = this.cutData.reduce(
        (prev, curr) => prev + Number.parseInt(curr.number_clusters),
        0
      );
      return Number.isNaN(result) ? 0 : result;
    },
    totalCalibration() {
      let result = 0;
      this.cutData.forEach((data) => {
        result = result + data.number_clusters * data.calibration;
      });
      return (result / this.cutData.length).toFixed(2);
    },

    totalBoxes() {
      let result = this.boxesData.reduce(
        (prev, curr) => prev + Number.parseInt(curr.number_boxes),
        0
      );
      return Number.isNaN(result) ? 0 : result;
    },

    totalRejectedBoxes() {
      let result = this.boxesData.reduce(
        (prev, curr) => prev + Number.parseInt(curr.number_rejected),
        0
      );
      return Number.isNaN(result) ? 0 : result;
    },

    totalExportedBoxed() {
      let result = this.boxesData.reduce(
        (prev, curr) => prev + Number.parseInt(curr.number_exported),
        0
      );
      return Number.isNaN(result) ? 0 : result;
    },

    totalRecusados() {
      let result = 0;
      this.recusados.forEach((el) => {
        if (el.amount && !Number.isNaN(el.amount)) {
          result = result + Number.parseInt(el.amount);
        }
      });
      return result;
    },

    avaliableWeeks() {
      let selectedWeeks = this.cutData.map((week) => week.week);
      // return [8,9,10,11,12,13].filter((number) => !selectedWeeks.includes(number));
      return this.ribbonsWeeks.filter(
        (ribbon) => !selectedWeeks.includes(ribbon.week)
      );
    },
    avaliableBoxes() {
      return this.boxes.filter((box, index) => {
        return !this.boxesData.map((box) => box.box_id).includes(box.id);
      });
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },

    // avaliableMotivos(){
    //   let selectedMotivos = this.recusados.map((recusado) => recusado.id);
    //   console.log("selected: ",selectedMotivos);
    //   let test = this.motivos.filter((motivo) => !selectedMotivos.includes(motivo.id));
    //   console.log("motivos: ",this.motivos);
    //   console.log("el test: ",test);
    //   return test;
    // }
  },

  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    addWeek() {
      this.cutData.push({
        week: null,
        number_clusters: null,
        calibration: null,
      });
    },

    calcExported(index) {
      let boxes = this.boxesData[index]['number_boxes'];
      let rejected = this.boxesData[index]['number_rejected'];

      if (boxes < 0) {
        this.boxesData[index]['number_boxes'] = null;
      } else if (rejected < 0) {
        this.boxesData[index]['number_rejected'] = null;
      } else if (boxes && rejected) {
        this.boxesData[index]['number_exported'] = boxes - rejected;
      }
    },

    validateNegative(index, data) {
      if (data === 'rejected') {
        if (this.recusados[index].amount < 0)
          this.recusados[index].amount = null;
      }

      if (data === 'cutNumber') {
        if (this.cutData[index].number_clusters < 0)
          this.cutData[index].number_clusters = null;
      }

      if (data === 'cutCalibration') {
        if (this.cutData[index].calibration < 0)
          this.cutData[index].calibration = null;
      }

      if (data === 'general') {
        if (this.generalData[index].value < 0)
          this.generalData[index].value = null;
      }
    },

    changeWeek($event) {
      let ribbon = this.ribbonsWeeks.find((ribbon) => ribbon.week == $event);
      let cut = this.cutData.find((cut) => cut.week === ribbon.week);
      cut.ribbon_id = ribbon.ribbon_id;
      cut.color_code = ribbon.color_code;
    },

    deleteWeek(indexD) {
      this.cutData = this.cutData.filter((week, index) => indexD !== index);
    },

    addRecusado() {
      this.recusados.push({
        name: null,
        amount: null,
        id: null,
      });
    },

    deleteRecusado(indexD) {
      this.recusados = this.recusados.filter(
        (recusado, index) => indexD !== index
      );
    },

    addBox() {
      this.boxesData.push({
        number_boxes: null,
        number_rejected: null,
        number_exported: null,
        box_id: null,
        box_name: null,
      });
    },

    deleteBox(indexD) {
      this.boxesData = this.boxesData.filter((box, index) => indexD !== index);
    },

    validate() {
      if (!this.cutSummaryCatchingForm.farm_id) {
        let sel = document.getElementById('cut_summary_farm');
        sel.focus();
        sel.classList.add('custom-has-error');
        store.dispatch('utils/removeHasError', sel);
      } else if (!this.cutSummaryCatchingForm.date) {
        let sel = document.getElementById('cut_summary_date_picker');
        sel.focus();
        // sel.classList.add("custom-has-error");
        // store.dispatch("utils/removeHasError", sel);
      } else {
        this.messageAlert = null;
        this.loadSummary();
      }
    },

    loadSummary() {
      let data = {
        route: 'summary/cutsummarycatching',
        farm_id: this.cutSummaryCatchingForm.farm_id,
        date: moment(this.cutSummaryCatchingForm.date).format('Y-M-D'),
        calendar_sel: this.cutSummaryCatchingForm.calendar_sel,
      };

      this.showHideLoading(true);
      this.cleanData();
      Axios.postMasters(data)
        .then((response) => {
          this.summaryCatching = true;

          this.cutSummaryCatchingForm.cut_summary_id =
            response.data.cut_summary_id;
          this.generalData = response.data.generalData;
          this.cutData = response.data.cutData;
          this.totalDataCut = response.data.totalDataCut;
          this.totalDataGeneral = response.data.totalDataGeneral;
          this.recusados = response.data.recusados;
          // this.totalRecusados = response.data.totalRecusados;
          this.boxesData = response.data.boxesData;
          // this.totalBoxes = response.data.totalBoxes;
          this.ribbonsWeeks = response.data.ribbonsWeeks;

          try {
            this.messageAlert = response.data.closing.message;
          } catch (error) {
            this.messageAlert = null;
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.summaryCatching = false;
          this.showMessageErrors(error);
        });
    },

    cleanData() {
      (this.generalData = []),
        (this.cutData = []),
        (this.totalDataCut = []),
        (this.totalDataGeneral = []),
        (this.recusados = []),
        // this.totalRecusados = [],
        (this.boxesData = []),
        // this.totalBoxes = [],
        (this.ribbonsWeeks = []);
    },

    saveSummary() {
      // this.summaryCatching = false;
      let data = {
        id: this.cutSummaryCatchingForm.cut_summary_id,
        cut_summaries: {
          farm_id: this.cutSummaryCatchingForm.farm_id,
          date_save: this.cutSummaryCatchingForm.date,
        },
        generalData: this.generalData,
        cutData: this.cutData,
        recusados: this.recusados,
        boxesData: this.boxesData,
      };

      this.summaryCatching = false;

      if (this.cutSummaryCatchingForm.cut_summary_id) {
        data.route = 'summary/cutsummarycatching/update';
        Axios.updateMaster(data)
          .then((response) => {
            SweetAlert.success(response.data.message);
          })
          .catch((error) => {
            this.showMessageErrors(error);
          });
      } else {
        data.route = 'summary/cutsummarycatching/store';
        Axios.postMasters(data)
          .then((response) => {
            SweetAlert.success(response.data.message);
          })
          .catch((error) => {
            this.showMessageErrors(error);
          });
      }
    },

    deleteSummary() {
      let data = {
        route: 'summary/cutsummarycatching/destroy',
        id: this.cutSummaryCatchingForm.cut_summary_id,
      };
      Axios.destroyMaster(data)
        .then((response) => {
          this.summaryCatching = false;
          SweetAlert.success(response.data.message);
        })
        .catch((error) => {
          this.summaryCatching = false;
          this.showMessageErrors(error);
        });
    },

    showCalendar() {
      this.messageAlert = null;
      this.isShowCalendar = true;
      this.cutSummaryCatchingForm.calendar_sel = null;
      this.cutting = false;

      const element = Object.values(this.farms).find(
        (el) => el.id === this.cutSummaryCatchingForm.farm_id
      );
      if (element) {
        this.isShowCalendar = element.calendars.length > 1;
        this.cutSummaryCatchingForm.calendar_sel =
          element.calendars.length > 1
            ? null
            : element.calendars.length == 1
            ? element.calendars[0].id
            : null;
      }

      this.isShowCalendar = false;
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Axios.getMasters('farms/farms/onlyfruit')
        .then((response) => {
          this.farms = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });

      Axios.getMasters('rejecteds/causes')
        .then((response) => {
          this.causes = response.data.data;
        })
        .catch((error) => console.log(error));

      Axios.getMasters('boxes/boxes')
        .then((response) => {
          this.boxes = response.data.data;
        })
        .catch((error) => console.log(error));
    } else {
      this.showHideLoading();
    }
    Axios.getMasters('calendars/getyearsbusiness').then((response) => {
      this.years = response.data;
      this.showHideLoading();
    });
  },
};
</script>

<style scope></style>
